import React from "react";
import images from "../data/Images";
import { motion } from "framer-motion";
import TechnologySection from "./Techsection";

const Technology = () => {
  return (
    <div className="technology">
      {/* Hero Section */}
      <section className="bg-red-800 text-white py-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto px-6"
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-4">Technology</h1>
          <p className="text-lg md:text-xl">
            Advanced Security Solutions Backed by Innovation
          </p>
        </motion.div>
      </section>

      <TechnologySection />

      {/* Drone Section */}
      <section className="py-20 px-6 md:px-20 text-gray-800">
        <div className="grid md:grid-cols-2 gap-14 items-center">
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl font-bold text-[#c4122f] mb-4">
              Drone-Based Commercial Security
            </h2>
            <p className="text-lg mb-6 leading-relaxed">
              <strong>The New Way Security</strong> integrates{" "}
              <strong>aerial drones</strong> into commercial security programs,
              offering continuous monitoring of large-scale properties. Our
              licensed operators follow aviation safety standards to maximize
              efficiency and reliability.
            </p>
            <h3 className="text-xl font-semibold mb-3">Practical Uses:</h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-base text-gray-700">
              <li className="bg-white p-3 rounded-md shadow-sm hover:bg-gray-100 transition">
                🚛 Fleet & Logistics Protection
              </li>
              <li className="bg-white p-3 rounded-md shadow-sm hover:bg-gray-100 transition">
                📍 Perimeter Inspections
              </li>
              <li className="bg-white p-3 rounded-md shadow-sm hover:bg-gray-100 transition">
                🏗️ Construction Progress Tracking
              </li>
              <li className="bg-white p-3 rounded-md shadow-sm hover:bg-gray-100 transition">
                🎤 Public Event Coverage
              </li>
              <li className="bg-white p-3 rounded-md shadow-sm hover:bg-gray-100 transition">
                👥 Crowd & Traffic Monitoring
              </li>
              <li className="bg-white p-3 rounded-md shadow-sm hover:bg-gray-100 transition">
                🔍 Early Suspicious Activity Alerts
              </li>
            </ul>
            <div className="mt-8">
              <a
                href="/contact"
                className="inline-block bg-[#c4122f] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#a81025] transition"
              >
                REQUEST A DRONE DEMO
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <img
              src={images.drone}
              alt="Drone Surveillance"
              className="w-full rounded-xl shadow-lg"
            />
          </motion.div>
        </div>
      </section>

      {/* S2 Robot Section */}
      <section className="py-20 px-6 md:px-20 text-gray-800">
        <div className="grid md:grid-cols-2 gap-14 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <img
              src={images.s2robot}
              alt="The New Way S2 AI Robot"
              className="w-full rounded-xl shadow-2xl hover:shadow-red-600/40 transition duration-300"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl font-bold text-[#c4122f] mb-4">
              The New Way S2 Patrol Robot
            </h2>
            <p className="text-lg mb-5 leading-relaxed">
              The <strong>S2 patrol robot</strong> offers a fully autonomous
              indoor patrol system. Designed with advanced AI navigation, it
              moves seamlessly between areas, even managing elevators while
              engaging with people on-site.
            </p>
            <p className="text-lg mb-5 leading-relaxed">
              Built with a <strong>4K ultra-HD lens</strong> and{" "}
              <strong>real-time recognition technology</strong>, S2 can
              instantly identify threats such as smoke, fire, or unauthorized
              access while sending live alerts to{" "}
              <strong>The New Way Security</strong> command centers.
            </p>
            <div className="mt-6">
              <a
                href="/contact"
                className="inline-block bg-[#c4122f] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#a81025] transition"
              >
                BOOK A DEMO TODAY
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* P2 Robot Section */}
      <section className="py-20 px-6 md:px-20 text-gray-800">
        <div className="grid md:grid-cols-2 gap-14 items-center">
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl font-bold text-[#c4122f] mb-4">
              The New Way P2 Remote Guard Robot
            </h2>
            <p className="text-lg mb-5 leading-relaxed">
              The <strong>P2 security robot</strong> is a remote-controlled
              system designed for facilities that need real-time monitoring
              without on-site guards. It allows operators to oversee buildings
              virtually while maintaining two-way communication.
            </p>
            <p className="text-lg mb-5 leading-relaxed">
              With <strong>4K HD streaming</strong> and{" "}
              <strong>instant communication tools</strong>, P2 ensures effective
              incident response, accurate visitor identification, and detailed
              surveillance reporting for management teams.
            </p>
            <div className="mt-6">
              <a
                href="/contact"
                className="inline-block bg-[#c4122f] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#a81025] transition"
              >
                CONTACT US FOR A QUOTE
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <img
              src={images.p2Robot}
              alt="The New Way P2 Robot"
              className="w-full rounded-xl shadow-2xl hover:shadow-red-600/40 transition duration-300"
            />
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Technology;
